module.exports = __webpack_public_path__ + "img/volume-up.4685354d.svg";